import zeroFill from 'helpers/transforms/zero-fill'

export const dateString = () => {
  const d = new Date()
  return [
    d.getFullYear(),
    zeroFill(d.getMonth() + 1, 2),
    zeroFill(d.getDate(), 2)
  ].join('')
}

export default dateString



// WEBPACK FOOTER //
// ./src/helpers/generators/date-string.js